export default __webpack_public_path__ + "static/media/5.c4a41b93.jpg";